import React, { useEffect, useState } from "react";
import OrderLinesTable from "../../../../components/Orders/OrderLinesTable";
import {
  Container,
  Card,
  Row,
  Col,
  Button,
  Spinner,
  Alert,
  Form,
  Modal,
  ProgressBar,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { withStyles } from "@material-ui/core/styles";
import { FormControlLabel, Switch, Badge, Chip } from "@material-ui/core";
import { useParams, useHistory } from "react-router-dom";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { io } from "socket.io-client";
import {
  MdCancel,
  MdLocalPrintshop,
  MdArrowBackIosNew,
  MdOutlineCreditCardOff,
  MdOutlineCreditCard,
  MdMap,
  MdRefresh,
  MdLocationOn,
  MdStorefront,
  MdAnalytics,
  MdDirections,
  MdWarning,
  MdRadar,
  MdShoppingCart,
  MdDescription,
  MdPerson,
  // MdAttachMoney,
  MdShowChart,
  MdLocalShipping,
  MdUndo,
  MdBolt,
  MdSportsMotorsports,
  MdContentCopy,
  MdCheck,
} from "react-icons/md";
import { toast } from "react-toastify";
import axios from "axios";
// import { FaPhoneAlt } from "react-icons/fa";
import {
  assignRestaurantOrderToDeliveryAgent,
  getOrderDetailsToProcess,
  markOrderAsPaid,
  re_assignRestaurantOrderToDeliveryAgent,
  updateRestaurantOrderDeliveryStatus,
} from "../../../../actions/webOrderActions";
// import { RECEIPT_URL } from "../../../../api/receiptUrl";
import { RESET_UPDATE_DELIVERY_STATUS_COMPLETE } from "../../../../constants/webOrderConstants";
import "./RestaurantOrderDetails.css";
import { getUserFromLocalStorage } from "../../../../utilities/user.js";
import RiderSelectionDropdown from "./RiderSelectionDropdown";
import { isRiderAssignmentLocked } from "../../../../utilities/orderRiderLock";
import ThreePLPartnerDropdown from "../../../../components/ThreePLPartnerDropdown";
import CancelOrderFields, { useCancellationReason, CancellationRecord } from "../../../../components/Orders/CancelOrderFields";
import ContactAction from "../../../../components/Orders/ContactAction";
import OrderNextStep from "../../../../components/Orders/OrderNextStep";
import socketAuthOptions from "../../../../utilities/socketAuth";
import { attachVendorOrderRooms } from "../../../../hooks/useVendorOrderRooms";
import { vendorOwnerIdOf } from "../../../../utilities/vendorScope";
import useOrderLiveUpdates from "../../../../hooks/useOrderLiveUpdates";
import DropoffMap from "../../../../components/Maps/DropoffMap";
import VendorHandoffActions from "../../../../components/Orders/VendorHandoffActions";
import { getShippingAddressText } from "../../../../utilities/orderPresentation";
import { openReceiptForPrint } from "../../../../utilities/openReceipt";
import DeliveryScheduleBadge from "../../../../components/DeliveryScheduleBadge";
import {
  getDeliveryStep,
  getDeliveryProgress,
  canVendorDispatch,
  canVendorMarkDelivered,
} from "../../../../utilities/orderDeliverySteps";
// An ordered dish may have no photograph yet (menus are imported before
// the shoot), so these thumbnails need a fallback rather than a broken box.
// Fork, plate and knife on a plain near-white field: the restaurant
// placeholder for a dish that has not been photographed yet.
import menuPlaceholder from "assets/img/restaurant-dish-placeholder.png";
import { useGate } from "../../../../components/team/Gated";
import AppSelect from "../../../../components/ui/AppSelect";

const API_URL = process.env.REACT_APP_SERVER_URL;

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: "#52d869",
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "#52d869",
      border: "6px solid #fff",
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

const isDevelopment = process.env.NODE_ENV === "development";

const RestaurantVendorOrderDetails = () => {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const user = getUserFromLocalStorage();

  const [showCancelModal, setShowCancelModal] = useState(false);
  // Reason + note for the audit record. Required by the server on cancel.
  const cancelReason = useCancellationReason();
  const [riders, setRiders] = useState([]);
  const [riderId, setRiderId] = useState("");
  // Vendor team permissions: every status, dispatch, rider and 3PL change
  // on this page is orders:manage (components/team/Gated.js).
  const ordersGate = useGate("orders:manage");

  // const [receiptLoading, setReceiptLoading] = useState(false);
  const [loadingRiders, setLoadingRiders] = useState(true);
  const [assignedRider, setAssignedRider] = useState(null);
  const [selectedAssignmentRider, setSelectedAssignmentRider] = useState(null);
  const [elapsedAssignedTime, setElapsedAssignedTime] = useState(0);
  const [elapsedDispatchedTime, setElapsedDispatchedTime] = useState(0);

  const [showMapModal, setShowMapModal] = useState(false);

  // 3PL Partner assignment state
  const [assignmentMode, setAssignmentMode] = useState("rider"); // "rider" or "3pl"
  const [selectedPartnerId, setSelectedPartnerId] = useState("");
  const [assigning3PL, setAssigning3PL] = useState(false);
  const [recalling3PL, setRecalling3PL] = useState(false);
  const [showRecallModal, setShowRecallModal] = useState(false);
  const [autoAssigning, setAutoAssigning] = useState(false);
  const [autoAssignEnabled, setAutoAssignEnabled] = useState(false);

  const mobileOrderDeliver = useSelector((state) => state.mobileOrderDeliver);
  const { loading: loadingDeliver, success: successDeliver } =
    mobileOrderDeliver;

  const orderDetails = useSelector((state) => state.orderDetails);
  const {
    order,
    loading,
    error,
    isUpdateDeliveryStatusComplete,
    paymentResult,
  } = orderDetails;

  // Live order news (a rider's pickup, a 3PL delivery, a decline) through the
  // one shared feed; see hooks/useOrderLiveUpdates.js. The page-level
  // listeners this replaces put `{ _id, delivery_status }` in the store as
  // the whole order, blanking the items.
  useOrderLiveUpdates(id, {
    onChange: (fresh) => {
      if (fresh?.delivery_status === "PROCESSING" && !fresh?.riderId) setRiderId("");
    },
  });

  const [isDataLoaded, setIsDataLoaded] = useState(false);

  useEffect(() => {
    if (!id) return;
    dispatch(getOrderDetailsToProcess(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (isUpdateDeliveryStatusComplete) {
      dispatch({ type: RESET_UPDATE_DELIVERY_STATUS_COMPLETE });
    }
  }, [isUpdateDeliveryStatusComplete, dispatch]);

  useEffect(() => {
    if (order?.riderId) {
      setRiderId(
        typeof order.riderId === "object" ? order.riderId._id : order.riderId
      );
    }
  }, [order?.riderId]);

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  useEffect(() => {
    if (order?.riderId && riders.length) {
      setAssignedRider(riders.find((rider) => rider._id === order.riderId._id));
    }
  }, [order, riders]);

  useEffect(() => {
    if (order && order.orderItems && order.orderItems.length > 0) {
      setIsDataLoaded(true);
    }
  }, [order]);

  const socketUrl = process.env.REACT_APP_SERVER_URL;

  useEffect(() => {
    // Authenticated: without a token the server treats this socket as
    // anonymous, and every gated handler (joinVendorRoom, getRiders scoping)
    // silently refuses. See utilities/socketAuth.js.
    const socket = io(
      socketUrl,
      socketAuthOptions({ userId: user?.result?._id })
    );

    socket.on("connect", () => {
      if (isDevelopment) {
        console.log("Webclient Connected");
      }
      // Emit the getRiders event after connecting
      socket.emit("getRiders");
    });

    // The vendor's order rooms carry the auto-assign feedback. One join that
    // names the owner (a team member named itself before and heard nothing);
    // the server picks the whole business or this member's branches.
    const ownerId = vendorOwnerIdOf(user);
    const stopRooms = attachVendorOrderRooms(socket, ownerId, {
      fallback: (s) => s.emit("joinVendorRoom", ownerId),
    });

    socket.on("initialRidersList", (socketData) => {
      setRiders(socketData);
      setLoadingRiders(false);
    });

    socket.on("updatedRidersList", (updatedRiders) => {
      setRiders(updatedRiders);
    });

    socket.on("riderAdded", (newRider) => {
      setRiders((prevRiders) => [...prevRiders, newRider]);
    });

    socket.on("riderUpdated", (updatedRider) => {
      setRiders((prevRiders) =>
        prevRiders.map((rider) =>
          rider._id === updatedRider._id ? updatedRider : rider
        )
      );
    });

    socket.on("riderDeleted", (deletedRider) => {
      setRiders((prevRiders) =>
        prevRiders.filter((rider) => rider._id !== deletedRider._id)
      );
    });

    // Auto-assign feedback — only process events for the current order
    socket.on("autoAssign:assigned", (data) => {
      if (data.orderId !== id) return;
      setAutoAssigning(false);
      setAutoAssignEnabled(false);
      const riderName = data.riderName || "a rider";
      toast.success(`Order auto-assigned to ${riderName}`);
      dispatch(getOrderDetailsToProcess(id));
    });

    socket.on("autoAssign:result", (data) => {
      if (data.orderId !== id) return;
      setAutoAssigning(false);
      setAutoAssignEnabled(false);
      if (data.status === "exhausted" || data.status === "no_riders") {
        toast.warn("No available in-house riders found. Please assign manually.");
      }
    });

    return () => {
      stopRooms();
      socket.disconnect();
    };
  }, [user?.result?._id, dispatch, id]);

  const handleBack = () => {
    history.push("/admin/resOrdersTable");
  };

  const handleUpdateStatus = (newStatus) => {
    if (newStatus === "ASSIGNED" && !riderId) {
      toast.warn("Please select a rider before assigning the order.");
      return;
    }
    if (newStatus === "ASSIGNED") {
      assignRestaurantOrderToRider();
    } else {
      dispatch(updateRestaurantOrderDeliveryStatus(order?._id, newStatus));
    }
  };

  const handleCancelOrder = () => {
    // Refuse locally too, so the modal explains itself instead of
    // bouncing off a 400 from the server.
    if (!cancelReason.validate()) return;
    const delivery_status = "REJECTED";
    // 
    dispatch(updateRestaurantOrderDeliveryStatus(order?._id, delivery_status, cancelReason.payload()));
    setShowCancelModal(false);
    cancelReason.reset();
  };

  // The receipt is its own document (the fiscal receipt with the EFRIS
  // markings when issued), not a print of this page.
  const handlePrint = () => openReceiptForPrint(order?._id);

  const handleMarkAsPaid = () => {
    if (user?.result?.userType !== "LUSUKU STAFF" && user?.result?.user_role !== "SUPERUSER") {
      toast.warn("🚫 You are not authorized to mark order as paid!");
      return;
    } else if (order?.isPaid) {
      toast.info("This order is already marked as paid.");
      return;
    } else {
      dispatch(markOrderAsPaid(order?._id));
    }
  };

  const assignRestaurantOrderToRider = () => {
    const delivery_status = "ASSIGNED";
    const assignedTime = Date.now();
    const selectedRider =
      (selectedAssignmentRider?._id === riderId && selectedAssignmentRider) ||
      riders.find((r) => r._id === riderId);
    const isCodFlagged = selectedRider?.codCash?.isFlagged === true;
    toast.success(`Assigning order ${order?._id} to rider ${riderId}`);
    localStorage.setItem(`order_${order?._id}_assignedTime`, assignedTime);
    dispatch(
      assignRestaurantOrderToDeliveryAgent(order?._id, riderId, delivery_status, isCodFlagged)
    );
  };

  // Trigger vendor auto-assignment using in-house riders
  const handleVendorAutoAssign = async () => {
    const vendorId = vendorOwnerIdOf(user);
    if (!vendorId) {
      toast.warn("Vendor ID not found");
      setAutoAssignEnabled(false);
      return;
    }
    setAutoAssigning(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${API_URL}/weborders/${order?._id}/vendor-auto-assign`,
        { vendorId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.success) {
        toast.success("Auto-assigning to nearest available rider…");
        setTimeout(() => dispatch(getOrderDetailsToProcess(order?._id)), 4000);
      } else {
        toast.error(response.data.error?.message || "Auto-assign failed");
        setAutoAssignEnabled(false);
      }
    } catch (error) {
      toast.error(
        error.response?.data?.error?.message || "Failed to trigger auto-assign"
      );
      setAutoAssignEnabled(false);
    } finally {
      setAutoAssigning(false);
    }
  };

  // Assign order to 3PL Partner
  const assignOrderTo3PLPartner = async () => {
    if (!selectedPartnerId) {
      toast.warn("Please select a 3PL partner");
      return;
    }

    setAssigning3PL(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${API_URL}/weborders/${order?._id}/assign-to-3pl`,
        { partnerId: selectedPartnerId },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data.success) {
        toast.success(response.data.message || "Order assigned to 3PL partner!");
        dispatch(getOrderDetailsToProcess(order?._id));
      } else {
        toast.error(response.data.error?.message || "Failed to assign order");
      }
    } catch (error) {
      console.error("Error assigning to 3PL:", error);
      toast.error(
        error.response?.data?.error?.message || "Failed to assign to 3PL partner"
      );
    } finally {
      setAssigning3PL(false);
    }
  };

  // Recall order from 3PL Partner
  const recallOrderFrom3PL = async () => {
    setShowRecallModal(false);
    setRecalling3PL(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${API_URL}/weborders/${order?._id}/recall-from-3pl`,
        { reason: "Recalled by vendor" },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data.success) {
        toast.success(response.data.message || "Order recalled successfully!");
        dispatch(getOrderDetailsToProcess(order?._id));
      } else {
        toast.error(response.data.error?.message || "Failed to recall order");
      }
    } catch (error) {
      console.error("Error recalling from 3PL:", error);
      toast.error(
        error.response?.data?.error?.message || "Failed to recall order from 3PL partner"
      );
    } finally {
      setRecalling3PL(false);
    }
  };


  const handleDispatchRestaurantOrder = () => {
    const delivery_status = "DISPATCHED";
    const dispatchedTime = Date.now();
    // console.log(`Dispatching order ${order?._id}`);
    localStorage.setItem(`order_${order?._id}_dispatchedTime`, dispatchedTime);
    dispatch(updateRestaurantOrderDeliveryStatus(order?._id, delivery_status));
    setTimeout(() => {
      dispatch(getOrderDetailsToProcess(order?._id));
    }, 500);
  };

  const handleDeliverRestaurantOrder = () => {
    const delivery_status = "DELIVERED";
    dispatch(updateRestaurantOrderDeliveryStatus(order?._id, delivery_status));
    setTimeout(() => {
      dispatch(getOrderDetailsToProcess(order?._id));
    }, 500);
  };

  // The delivery ladder lives in utilities/orderDeliverySteps.js so the
  // tracker, the next-step banner and the action buttons can never disagree
  // about where an order is. This was a four-case switch whose `default: 0`
  // emptied the progress bar for the six statuses this page never writes
  // itself: ACCEPTED and PICKED_UP come from the rider app
  // (OrderDetailsScreen / DispatchOrderScreen), PENDING_3PL / IN_TRANSIT /
  // ARRIVED from the 3PL rail, FULFILLED from the counter. A rider tapping
  // Accept therefore made the vendor's screen look like the order had gone
  // backwards to zero.
  //
  // NOTE: there is no "PAID" delivery_status. Payment state lives in
  // `isPaid`/`paymentStatus` (see utilities/paymentStatus.js); the
  // delivery_status enum in models/Orders.js has no such member.
  const getProgress = () => getDeliveryProgress(order);

  // Where the order sits, and the sentence that tells the vendor what to do
  // next. Recomputed on every render so a socket status push moves it.
  const deliveryStep = getDeliveryStep(order);

  const getProgressBarStyle = () => {
    switch (order?.delivery_status) {
      case "DELIVERED":
        return { backgroundColor: "green", color: "white" };
      default:
        return {};
    }
  };

  const getBadgeStyle = (status) => {
    switch (status) {
      case "PROCESSING":
        return {
          backgroundColor: "#e67e22",
          color: "white",
          borderRadius: "20px",
          padding: "8px 16px",
          fontWeight: "600",
          fontSize: "12px",
          display: "inline-flex",
          justifyContent: "center",
          alignItems: "center",
        };
      case "ASSIGNED":
        return {
          backgroundColor: "blue",
          color: "white",
          borderRadius: "10px",
          padding: "5px",
        };
      case "PENDING_3PL":
        return {
          backgroundColor: "#9b59b6",
          color: "white",
          borderRadius: "10px",
          padding: "5px",
        };
      case "ACCEPTED":
        return {
          backgroundColor: "#00897b",
          color: "white",
          borderRadius: "10px",
          padding: "5px",
        };
      case "PICKED_UP":
        return {
          backgroundColor: "#2196f3",
          color: "white",
          borderRadius: "10px",
          padding: "5px",
        };
      case "DISPATCHED":
        return {
          backgroundColor: "purple",
          color: "white",
          borderRadius: "10px",
          padding: "5px",
        };
      case "DELIVERED":
        return {
          backgroundColor: "green",
          color: "white",
          borderRadius: "10px",
          padding: "5px",
        };
      case "REJECTED":
        return {
          backgroundColor: "red",
          color: "white",
          borderRadius: "10px",
          padding: "5px",
        };
      default:
        return {
          backgroundColor: "grey",
          color: "white",
          borderRadius: "10px",
          padding: "5px",
        };
    }
  };

  const getPaidBadgeStyle = (isPaid) => {
    return {
      backgroundColor: isPaid ? "green" : "#2C3A40",
      color: "white",
      borderRadius: "10px",
      padding: "3px",
    };
  };

  // Only an order still in PROCESSING can be cancelled here. This used to also
  // accept a "PAID" delivery_status, which is not a member of the delivery_status
  // enum and could never be stored — dead code that made the rule look broader
  // than it is. Behaviour is unchanged.
  const canCancelOrder = order?.delivery_status === "PROCESSING";

  const getDisabledStatusOptions = () => {
    const disabledOptions = {
      PROCESSING: order?.delivery_status !== "PROCESSING",
      ASSIGNED:
        order?.delivery_status !== "PROCESSING" &&
        order?.delivery_status !== "ASSIGNED",
      // Gated through the shared ladder rather than a literal "previous
      // status" test: a rider who has already marked the order ACCEPTED or
      // PICKED_UP used to leave the vendor with every option greyed out.
      DISPATCHED:
        !canVendorDispatch(order) &&
        order?.delivery_status !== "DISPATCHED",
      DELIVERED:
        !canVendorMarkDelivered(order) &&
        order?.delivery_status !== "DELIVERED",
      REJECTED:
        order?.delivery_status === "DELIVERED" ||
        order?.delivery_status === "REJECTED",
    };
    return disabledOptions;
  };

  const disabledStatusOptions = getDisabledStatusOptions();

  useEffect(() => {
    if (order?.delivery_status === "ASSIGNED") {
      const storedAssignedTime = localStorage.getItem(
        `order_${order?._id}_assignedTime`
      );
      if (storedAssignedTime) {
        const elapsed = Math.floor(
          (Date.now() - parseInt(storedAssignedTime, 10)) / 1000
        );
        setElapsedAssignedTime(elapsed);
      }
    }
    if (order?.delivery_status === "DISPATCHED") {
      const storedDispatchedTime = localStorage.getItem(
        `order_${order?._id}_dispatchedTime`
      );
      if (storedDispatchedTime) {
        const elapsed = Math.floor(
          (Date.now() - parseInt(storedDispatchedTime, 10)) / 1000
        );
        setElapsedDispatchedTime(elapsed);
      }
    }

    const interval = setInterval(() => {
      if (order?.delivery_status === "ASSIGNED") {
        setElapsedAssignedTime((prev) => prev + 1);
      }
      if (order?.delivery_status === "DISPATCHED") {
        setElapsedDispatchedTime((prev) => prev + 1);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [order?.delivery_status, order?._id]);

  // calculate distance using the Haversine formula
  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Radius of the Earth in kilometers
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distance in kilometers
    return distance.toFixed(2);
  };

  if (loading) {
    return (
      <Container
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "80vh",
        }}
      >
        <Spinner
          animation="grow"
          // variant="primary"
          role="status"
          style={{
            width: "3rem",
            color: "#00aa00e4",
            height: "3rem"
          }}
        >
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Alert variant="danger" className="mt-3">
          {error}
        </Alert>
      </Container>
    );
  }

  if (!order || !order.orderItems || order.orderItems.length === 0) {
    return (
      <Container>
        <Alert variant="info">No order details available</Alert>
      </Container>
    );
  }

  const handleShowMap = () => {
    setShowMapModal(true);
  };

  const handleCloseMap = () => {
    setShowMapModal(false);
  };

  // Reassign order to a new rider

  const handleReassignOrder = () => {
    const delivery_status = "PROCESSING";
    const currentRiderId =
      typeof order?.riderId === "object" ? order?.riderId?._id : order?.riderId;
    if (order?._id && currentRiderId) {
      dispatch(
        re_assignRestaurantOrderToDeliveryAgent(
          order?._id,
          currentRiderId,
          delivery_status,
          true
        )
      );
    } else {
      toast.error("No rider currently assigned to this order.");
    }
  };

  return (
    <Container fluid className="order-details-container" style={{ fontSize: "13px" }}>
      <Row className="mb-3">
        <Col md="12">
          <Button
            variant="outline-primary"
            onClick={handleBack}
            className="d-flex align-items-center enhanced-button"
            style={{
              background: "#013A63",
              color: "white",
              border: "none",
            }}
          >
            <MdArrowBackIosNew style={{ marginRight: "8px" }} />
            Back to Orders
          </Button>
        </Col>
      </Row>

      <Row>
        <Col md="12">
          <Card className="shadow enhanced-card">
            <Card.Header
              className="gradient-header rod-card-header-inner"
              style={{
                padding: "20px 25px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "none",
                background: "#013A63",
                borderRadius: "8px 8px 0 0",
              }}
            >
              <div>
                <Card.Title
                  as="h4"
                  style={{ color: "white", marginBottom: "6px", fontSize: "16px", fontWeight: 700 }}
                >
                  Menu Order Details
                </Card.Title>
                <DeliveryScheduleBadge order={order} style={{ marginBottom: 6 }} />
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <span
                    style={{
                      color: "#fff",
                      fontSize: "13px",
                      fontWeight: 700,
                      fontFamily: "monospace",
                      letterSpacing: "0.5px",
                      background: "rgba(255,255,255,0.15)",
                      borderRadius: "6px",
                      padding: "3px 10px",
                      border: "1px solid rgba(255,255,255,0.25)",
                    }}
                  >
                    #{order?._id}
                  </span>
                  <OverlayTrigger
                    placement="right"
                    overlay={<Tooltip>Copy order ID</Tooltip>}
                  >
                    <button
                      onClick={() => {
                        navigator.clipboard.writeText(order?._id);
                        toast.success("Order ID copied!", { autoClose: 1500 });
                      }}
                      style={{
                        background: "rgba(255,255,255,0.15)",
                        border: "1px solid rgba(255,255,255,0.25)",
                        borderRadius: "6px",
                        color: "#fff",
                        cursor: "pointer",
                        padding: "3px 7px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <MdContentCopy style={{ fontSize: "14px" }} />
                    </button>
                  </OverlayTrigger>
                </div>
                {order?.createdAt && (
                  <div
                    style={{
                      color: "rgba(255,255,255,0.85)",
                      fontSize: "12px",
                      marginTop: "6px",
                      letterSpacing: "0.3px",
                    }}
                  >
                    {moment(order.createdAt).format("MMM D, YYYY · h:mm a")}
                  </div>
                )}
              </div>
              <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                <VendorHandoffActions orderId={order?._id} />
                <Button
                  variant="outline-light"
                  onClick={handlePrint}
                  className="d-flex align-items-center enhanced-button rod-print-btn"
                  style={{
                    gap: "8px",
                    background: "rgba(255, 255, 255, 0.2)",
                    backdropFilter: "blur(10px)",
                    border: "2px solid rgba(255, 255, 255, 0.3)",
                  }}
                >
                  <MdLocalPrintshop />
                  Print Receipt
                </Button>
              </div>
            </Card.Header>

            {/* Sticky step-progress tracker — lives OUTSIDE Card.Body so
                position:sticky anchors to page scroll, not a nested scroller */}
            {isDataLoaded && order?.orderItems?.length > 0 && (() => {
              const steps = [
                { key: "PROCESSING", label: "Processing", pct: 20 },
                { key: "ASSIGNED",   label: "Assigned",   pct: 40 },
                { key: "DISPATCHED", label: "Dispatched", pct: 60 },
                { key: "DELIVERED",  label: "Delivered",  pct: 100 },
              ];
              const currentPct = getProgress();
              const isRejected = order?.delivery_status === "REJECTED";
              return (
                <div
                  className="rod-step-tracker"
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 100,
                    background: "#ffffff",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.10)",
                    padding: "14px 24px 10px",
                    borderBottom: "1px solid #e9ecef",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
                    {/* Background track */}
                    <div style={{ position: "absolute", top: "14px", left: "20px", right: "20px", height: "4px", backgroundColor: "#e9ecef", borderRadius: "2px" }} />
                    {/* Filled track */}
                    <div style={{ position: "absolute", top: "14px", left: "20px", height: "4px", width: isRejected ? "0%" : `${Math.min(currentPct, 100)}%`, backgroundColor: isRejected ? "#dc3545" : currentPct === 100 ? "#28a745" : "#013A63", borderRadius: "2px", transition: "width 0.4s ease" }} />
                    {steps.map((step, i) => {
                      const done = !isRejected && currentPct >= step.pct;
                      const active = !isRejected && deliveryStep.stage === i;
                      return (
                        <div key={step.key} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: i === 0 ? "flex-start" : i === steps.length - 1 ? "flex-end" : "center", position: "relative", zIndex: 1 }}>
                          <div className="rod-step-dot" style={{ width: 28, height: 28, borderRadius: "50%", backgroundColor: done ? (currentPct === 100 ? "#28a745" : "#013A63") : "#fff", border: active ? "3px solid #013A63" : done ? "none" : "2px solid #dee2e6", display: "flex", alignItems: "center", justifyContent: "center", transition: "background 0.3s", boxShadow: active ? "0 0 0 4px rgba(1,58,99,0.15)" : "none" }}>
                            {done ? <MdCheck style={{ color: "#fff", fontSize: "16px" }} /> : <span style={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: active ? "#013A63" : "#dee2e6", display: "inline-block" }} />}
                          </div>
                          <span className="rod-step-label" style={{ fontSize: "10px", fontWeight: active ? 700 : done ? 600 : 400, color: active ? "#013A63" : done ? "#495057" : "#adb5bd", marginTop: "5px", whiteSpace: "nowrap" }}>{step.label}</span>
                        </div>
                      );
                    })}
                  </div>
                  {/* Sits inside the sticky tracker on purpose: the one
                      thing a vendor needs while scrolling a long order is what
                      to do next and who they are waiting on. Shared with the
                      retailer, healthcare and brand pages. */}
                  <OrderNextStep order={order} style={{ marginTop: "10px" }} />
                </div>
              );
            })()}

            <Card.Body>
              {isDataLoaded && order?.orderItems?.length > 0 ? (
                <>
                  <Row>
                    <Col md="6" className="rod-left-col" style={{ borderRight: "2px dashed #dee2e6", paddingRight: "24px" }}>
                      <div className="section-title">
                        <h5 style={{ fontSize: "16px", fontWeight: 700 }}>
                          <MdShoppingCart style={{ marginRight: "8px", fontSize: "18px" }} />
                          Order Items
                        </h5>
                      </div>
                      <div className="rod-items-table-wrap" style={{ overflow: "visible" }}>
                        <OrderLinesTable order={order} placeholderImage={menuPlaceholder} />
                      </div>

                      {/* Assignment panel — directly below items table, no gap */}
                      <Form.Group
                        controlId="formAssignment"
                        className="shadow p-3 mt-3"
                        style={{ boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)" }}
                      >
                        {/* Assignment Mode Toggle */}
                        {!order?.riderId && order?.delivery_status === "PROCESSING" && (
                          <div className="mb-3">
                            <Form.Label style={{ color: "#012030", fontWeight: "bold" }}>
                              Assignment Type
                            </Form.Label>
                            {/* A segmented control, not two competing buttons.
                                These are two values of ONE choice, so they get
                                one visual language and differ only by which is
                                selected — the previous blue-vs-orange pair read
                                as two unrelated actions of different weight.
                                The auto-assign switch moved to its own row
                                below: it was a third item in this flex row with
                                an unconstrained label, so the text wrapped onto
                                four lines and stretched the whole panel. */}
                            <div
                              role="radiogroup"
                              aria-label="Assignment type"
                              style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}
                            >
                              {[
                                { key: "rider", label: "Assign to rider", Icon: MdSportsMotorsports },
                                { key: "3pl", label: "Assign to 3PL partner", Icon: MdLocalShipping },
                              ].map(({ key, label, Icon }) => {
                                const active = assignmentMode === key;
                                return (
                                  <button
                                    key={key}
                                    type="button"
                                    role="radio"
                                    aria-checked={active}
                                    onClick={() => setAssignmentMode(key)}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      gap: 7,
                                      padding: "10px 12px",
                                      borderRadius: 8,
                                      cursor: "pointer",
                                      fontSize: "13px",
                                      fontWeight: 600,
                                      lineHeight: 1.2,
                                      textAlign: "center",
                                      transition: "background-color .12s ease, border-color .12s ease",
                                      border: active ? "1px solid #013A63" : "1px solid #d5dbe3",
                                      backgroundColor: active ? "#013A63" : "#ffffff",
                                      color: active ? "#ffffff" : "#48566a",
                                      boxShadow: active ? "0 1px 2px rgba(1,58,99,.25)" : "none",
                                    }}
                                  >
                                    <Icon style={{ fontSize: "16px", flexShrink: 0 }} />
                                    <span>{label}</span>
                                  </button>
                                );
                              })}
                            </div>

                            {/* Auto-assign: its own row, label beside the switch
                                with room to sit on one line, and a line of
                                explanation so the vendor knows what flipping it
                                actually does. */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: 10,
                                marginTop: 12,
                                paddingTop: 12,
                                borderTop: "1px solid #eef1f5",
                              }}
                            >
                              <Switch
                                checked={autoAssignEnabled}
                                onChange={(e) => {
                                  const checked = e.target.checked;
                                  setAutoAssignEnabled(checked);
                                  if (checked) handleVendorAutoAssign();
                                }}
                                disabled={(autoAssigning) || !ordersGate.allowed}
                                title={ordersGate.title}
                                size="small"
                                inputProps={{ "aria-label": "Auto-assign this order to the nearest rider" }}
                                style={{ marginLeft: -6, marginTop: -4 }}
                              />
                              <div style={{ minWidth: 0 }}>
                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#1f2937", display: "flex", alignItems: "center", gap: 5 }}>
                                  {autoAssigning ? (
                                    <>
                                      <Spinner animation="border" style={{ width: "12px", height: "12px", borderWidth: "2px" }} />
                                      Finding a rider…
                                    </>
                                  ) : (
                                    <>
                                      <MdBolt style={{ fontSize: "15px", color: "#b45309", flexShrink: 0 }} />
                                      Auto-assign to nearest rider
                                    </>
                                  )}
                                </div>
                                <div style={{ fontSize: "11.5px", color: "#7b8794", lineHeight: 1.45, marginTop: 2 }}>
                                  {autoAssigning
                                    ? "Trying the closest available riders in turn."
                                    : "Picks the closest rider who is online and free. You can still assign by hand."}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Show 3PL Partner Assignment if in PENDING_3PL status */}
                        {order?.delivery_status === "PENDING_3PL" && (
                          <Alert
                            style={{
                              backgroundColor: "rgba(11, 41, 71, 0.95)",
                              color: "white",
                              borderRadius: "12px",
                              padding: "16px 20px"
                            }}
                            className="mb-3"
                          >
                            <div className="d-flex justify-content-between align-items-start">
                              <div>
                                <div className="d-flex align-items-center mb-2">
                                  <MdLocalShipping style={{ marginRight: "8px", fontSize: "18px" }} />
                                  <strong style={{ fontSize: "13px" }}>Pending 3PL Assignment</strong>
                                </div>
                                <div style={{ opacity: 0.9, fontSize: "13px", lineHeight: 1.5 }}>
                                  Order sent to: <strong>{order?.assignmentDetails?.partnerId?.companyName || "Unknown"}</strong>
                                  <br />
                                  Waiting for 3PL to assign a rider.
                                </div>
                              </div>
                              <Button
                                variant="outline-danger"
                                size="sm"
                                style={{
                                  borderRadius: "8px",
                                  padding: "8px 16px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  fontWeight: "500",
                                  borderWidth: "2px",
                                  backgroundColor: "rgba(220, 38, 38, 0.1)",
                                  borderColor: "#dc2626",
                                  color: "#fff"
                                }}
                                onClick={() => setShowRecallModal(true)}
                                disabled={(recalling3PL) || !ordersGate.allowed}
                                title={ordersGate.title}
                              >
                                {recalling3PL ? (
                                  <>
                                    <Spinner animation="border" size="sm" />
                                    Recalling...
                                  </>
                                ) : (
                                  <>
                                    <MdUndo style={{ fontSize: "16px" }} />
                                    Recall Order
                                  </>
                                )}
                              </Button>
                            </div>
                          </Alert>
                        )}

                        {/* Rider Selection (when mode is 'rider').
                            Hidden for terminal orders — a cancelled/rejected
                            order can no longer be assigned to a rider. */}
                        {assignmentMode === "rider" &&
                          order?.delivery_status !== "PENDING_3PL" &&
                          order?.delivery_status !== "REJECTED" &&
                          order?.delivery_status !== "CANCELLED" &&
                          order?.delivery_status !== "CANCELED" && (
                          <RiderSelectionDropdown
                            order={order}
                            riderId={riderId}
                            setRiderId={setRiderId}
                            loadingRiders={loadingRiders}
                            riders={riders}
                            assignRestaurantOrderToRider={assignRestaurantOrderToRider}
                            elapsedAssignedTime={elapsedAssignedTime}
                            elapsedDispatchedTime={elapsedDispatchedTime}
                            onRiderSelect={(newRiderId, rider) => {
                              setRiderId(newRiderId);
                              setSelectedAssignmentRider(rider || null);
                            }}
                          />
                        )}

                        {/* 3PL Partner Selection */}
                        {assignmentMode === "3pl" && order?.delivery_status === "PROCESSING" && (
                          <>
                            <ThreePLPartnerDropdown
                              dropoff={order?.shippingAddress?.latLng}
                              selectedPartnerId={selectedPartnerId}
                              onSelectPartner={setSelectedPartnerId}
                              disabled={order?.delivery_status !== "PROCESSING"}
                            />
                            {selectedPartnerId && (
                              <Button
                                variant="success"
                                onClick={assignOrderTo3PLPartner}
                                className="mt-2"
                                style={{
                                  width: "100%",
                                  backgroundColor: assigning3PL ? "#8bc34a" : "#8bc34a",
                                  borderColor: "#8bc34a",
                                  color: "white"
                                }}
                                disabled={(!selectedPartnerId || assigning3PL) || !ordersGate.allowed}
                                title={ordersGate.title}
                              >
                                {assigning3PL ? (
                                  <>
                                    <Spinner animation="border" size="sm" className="me-2" style={{ color: "white" }} />
                                    <span style={{ color: "white" }}>Assigning...</span>
                                  </>
                                ) : (
                                  <>
                                    <MdLocalShipping style={{ marginRight: "5px" }} />
                                    Send to 3PL Partner
                                  </>
                                )}
                              </Button>
                            )}
                          </>
                        )}

                        {/* Re-assign button (for already assigned orders) */}
                        {order?.delivery_status !== "PROCESSING" &&
                          order?.delivery_status !== "PENDING_3PL" &&
                          !isRiderAssignmentLocked(order) && (
                            <Button
                              disabled={!ordersGate.allowed}
                              title={ordersGate.title}
                              variant="secondary"
                              onClick={handleReassignOrder}
                              className="mt-2"
                              style={{ width: "100%" }}
                            >
                              <MdRefresh style={{ marginRight: "5px" }} />
                              Re-assign Order to different Rider!
                            </Button>
                          )}
                      </Form.Group>

                    </Col>

                    <Col md="6" className="rod-right-col" style={{ paddingLeft: "24px" }}>
                      <div className="section-title">
                        <h5 style={{ fontSize: "16px", fontWeight: 700 }}>
                          <MdDescription style={{ marginRight: "8px", fontSize: "18px" }} />
                          Order Summary
                        </h5>
                      </div>
                      <Card className="summary-card">
                        <Card.Body style={{ padding: 0 }}>

                          {/* ── Customer Information ── */}
                          <div style={{ padding: "16px 20px", borderBottom: "1px solid #f0f2f5" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 12 }}>
                              <div style={{ width: 28, height: 28, borderRadius: "50%", backgroundColor: "#e8f0fe", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <MdPerson style={{ fontSize: 16, color: "#013A63" }} />
                              </div>
                              <span style={{ fontWeight: 700, fontSize: "12px", color: "#013A63", textTransform: "uppercase", letterSpacing: "0.6px" }}>
                                Customer
                              </span>
                            </div>
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px 4px" }}>
                              <div>
                                <div style={{ fontSize: "10px", color: "#9ca3af", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.4px", marginBottom: 2 }}>Name</div>
                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#1f2937" }}>{order?.customerName || order?.shippingAddress?.customerNumber || "—"}</div>
                              </div>
                              <div>
                                <div style={{ fontSize: "10px", color: "#9ca3af", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.4px", marginBottom: 2 }}>Phone</div>
                                <ContactAction
                                  label="Customer"
                                  name={order?.customerName}
                                  phone={order?.shippingAddress?.customerNumber || order?.shippingAddress?.recipientPhone}
                                  compact
                                />
                              </div>
                              <div>
                                <div style={{ fontSize: "10px", color: "#9ca3af", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.4px", marginBottom: 2 }}>Payment</div>
                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#1f2937" }}>{order?.paymentMethod || "—"}</div>
                              </div>
                            </div>
                            <div style={{ marginTop: 10 }}>
                              <div style={{ fontSize: "10px", color: "#9ca3af", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.4px", marginBottom: 4 }}>Delivery Address</div>
                              <div style={{ fontSize: "13px", fontWeight: 500, color: "#013A63", background: "#f0f4fa", borderRadius: 6, padding: "6px 10px", borderLeft: "3px solid #013A63" }}>
                                {getShippingAddressText(order?.shippingAddress, "No address recorded")}
                              </div>
                            </div>
                          </div>

                          {/* ── Price Breakdown ── */}
                          <div style={{ padding: "14px 20px", borderBottom: "1px solid #f0f2f5" }}>
                            <div style={{ fontSize: "10px", color: "#9ca3af", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.6px", marginBottom: 10 }}>Price Breakdown</div>
                            {/* VAT is CONTAINED in the items total, not added to
                                it — catalogue prices are tax-inclusive on every
                                customer-facing channel. Listing "Items 50,000 /
                                Delivery 9,000 / Tax 7,627" as three peers would
                                not add up to the total and would read as a
                                surcharge the customer never paid. So the net and
                                the VAT are shown indented beneath the items
                                line they decompose.

                                When the vendor is not VAT-registered the VAT
                                rows are OMITTED, never shown as zero: a zero VAT
                                line is a claim about tax, an absent line is not,
                                and a vendor below the threshold must not make
                                that claim. */}
                            {(() => {
                              const items = Number(order?.itemsPrice || 0);
                              const tax = Number(order?.taxPrice || 0);
                              const rateBps = order?.orderItems?.find((i) => i?.taxRateBpsSnapshot)?.taxRateBpsSnapshot;
                              const rows = [];
                              if (tax > 0) {
                                rows.push({ label: "Items excl. VAT", value: items - tax, sub: true });
                                rows.push({
                                  label: `VAT${rateBps ? ` (${rateBps / 100}%)` : ""} · included`,
                                  value: tax,
                                  sub: true,
                                });
                              }
                              rows.push({ label: "Items total", value: items });
                              rows.push({ label: "Delivery fee", value: Number(order?.deliveryFee || 0) });
                              return rows.map(({ label, value, sub }) => (
                                <div
                                  key={label}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: 6,
                                    paddingLeft: sub ? 10 : 0,
                                    borderLeft: sub ? "2px solid #eef1f5" : "none",
                                  }}
                                >
                                  <span style={{ fontSize: "12px", color: sub ? "#9ca3af" : "#6b7280" }}>{label}</span>
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: sub ? 500 : 600,
                                      color: sub ? "#7b8794" : "#374151",
                                      fontVariantNumeric: "tabular-nums",
                                    }}
                                  >
                                    Ush {(value || 0).toLocaleString()}
                                  </span>
                                </div>
                              ));
                            })()}
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10, paddingTop: 10, borderTop: "1px solid #e5e7eb" }}>
                              <span style={{ fontSize: "13px", fontWeight: 700, color: "#1f2937" }}>Total</span>
                              <span style={{ fontSize: "15px", fontWeight: 800, color: "#013A63" }}>Ush {(order?.totalPrice || 0).toLocaleString()}</span>
                            </div>
                          </div>

                          {/* ── Order Status ── */}
                          <div style={{ padding: "14px 20px" }}>
                            <div style={{ fontSize: "10px", color: "#9ca3af", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.6px", marginBottom: 10 }}>Order Status</div>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                              <span style={{ fontSize: "12px", color: "#6b7280" }}>Payment</span>
                              <Badge
                                overlap="rectangular"
                                style={{ ...getPaidBadgeStyle(order?.isPaid), fontSize: "12px", display: "inline-flex", alignItems: "center", gap: 4 }}
                              >
                                {order?.isPaid
                                  ? <><MdOutlineCreditCard /> Paid</>
                                  : <><MdOutlineCreditCardOff /> Unpaid</>
                                }
                              </Badge>
                            </div>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                              <span style={{ fontSize: "12px", color: "#6b7280" }}>Delivery</span>
                              <Badge
                                overlap="rectangular"
                                style={{ ...getBadgeStyle(order?.delivery_status), fontSize: "12px" }}
                              >
                                {order?.delivery_status}
                              </Badge>
                            </div>
                          </div>

                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>

                  <div style={{ borderTop: "2px dashed #dee2e6", margin: "20px 0" }} />

                  <Row>
                    <Col md="6">
                      <Form.Group
                        controlId="formOrderStatus"
                        className="shadow p-3"
                        style={{ boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.2)" }}
                      >
                        <Form.Label
                          style={{ color: "#012030", fontWeight: "bold" }}
                        >
                          Update Order Status
                        </Form.Label>
                        <AppSelect block
                          disabled={!ordersGate.allowed}
                          title={ordersGate.title}
                          value={order.delivery_status}
                          onChange={(e) => handleUpdateStatus(e.target.value)}
                        >
                          <option
                            value="PROCESSING"
                            disabled={disabledStatusOptions.PROCESSING}
                          >
                            1. Processing
                          </option>
                          <option
                            value="ASSIGNED"
                            disabled={disabledStatusOptions.ASSIGNED}
                          >
                            2. Assigned
                          </option>
                          <option
                            value="DISPATCHED"
                            disabled={disabledStatusOptions.DISPATCHED}
                          >
                            3. Dispatched
                          </option>
                          <option
                            value="DELIVERED"
                            disabled={disabledStatusOptions.DELIVERED}
                          >
                            4. Delivered
                          </option>
                          <option
                            value="REJECTED"
                            disabled={disabledStatusOptions.REJECTED}
                          >
                            5. Cancel Order
                          </option>
                        </AppSelect>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="mt-4">
                    <Col className="d-flex justify-content-end align-items-center rod-action-row">
                      <div
                        style={{
                          cursor: !canCancelOrder ? "not-allowed" : "pointer",
                          backgroundColor: !canCancelOrder
                            ? "#8C1F28"
                            : "transparent",
                          borderRadius: "5px",
                          padding: "2px",
                          marginRight: "5px",
                          width: "160px",
                          height: "40px",
                        }}
                      >
                        <Button
                          variant="danger"
                          onClick={() => setShowCancelModal(true)}
                          className="mr-2"
                          disabled={(!canCancelOrder) || !ordersGate.allowed}
                          title={ordersGate.title}
                          style={{
                            backgroundColor: !canCancelOrder
                              ? "transparent"
                              : "red",
                            color: !canCancelOrder ? "white" : "white",
                            border: "none",
                            fontSize: "13px",
                            width: "100%",
                            height: "100%",
                            padding: "6px",
                            boxShadow: "0 3px 8px rgba(0,0,0,0.9)",
                          }}
                        >
                          <MdCancel
                            style={{
                              fontSize: "18px",
                              justifyContent: "center",
                              alignItems: "center",
                              marginRight: "5px",
                            }}
                          />
                          Cancel Order
                        </Button>
                      </div>
                      {/* components/Orders/ContactAction: a real tel: link on
                          a phone, copy on a desktop. The old button only
                          raised a toast. */}
                      <ContactAction
                        label="Customer"
                        name={order?.customerName}
                        phone={order?.shippingAddress?.customerNumber || order?.shippingAddress?.recipientPhone}
                        style={{ marginRight: 5 }}
                      />
                    </Col>
                  </Row>

                  <Row className="mt-4">
                    <Col md="12" className="d-flex justify-content-between rod-dispatch-row">
                      <div
                        style={{
                          cursor:
                            !canVendorDispatch(order)
                              ? "not-allowed"
                              : "pointer",
                          backgroundColor:
                            !canVendorDispatch(order)
                              ? "#4B4952"
                              : "transparent",
                          borderRadius: "5px",
                          padding: "2px",
                        }}
                      >
                        <Button
                          variant="warning"
                          onClick={handleDispatchRestaurantOrder}
                          disabled={(!canVendorDispatch(order)) || !ordersGate.allowed}
                          title={ordersGate.title}
                          style={{
                            backgroundColor:
                              !canVendorDispatch(order)
                                ? "transparent"
                                : "orange",
                            color:
                              !canVendorDispatch(order)
                                ? "white"
                                : "black",
                            border: "none",
                            fontSize: "13px",
                            boxShadow: "0 2px 5px rgb(236, 234, 232)",
                          }}
                        >
                          Dispatch Order
                        </Button>
                      </div>
                      <div
                        style={{
                          cursor:
                            !canVendorMarkDelivered(order)
                              ? "not-allowed"
                              : "pointer",
                          backgroundColor:
                            !canVendorMarkDelivered(order)
                              ? "green"
                              : "transparent",
                          borderRadius: "5px",
                          padding: "2px",
                        }}
                      >
                        <Button
                          variant="success"
                          onClick={handleDeliverRestaurantOrder}
                          disabled={(!canVendorMarkDelivered(order)) || !ordersGate.allowed}
                          title={ordersGate.title}
                          style={{
                            backgroundColor:
                              !canVendorMarkDelivered(order)
                                ? "transparent"
                                : "green",
                            color:
                              !canVendorMarkDelivered(order)
                                ? "white"
                                : "black",
                            border: "none",
                            fontSize: "13px",
                            boxShadow: "0 2px 5px rgb(236, 234, 232)",
                          }}
                        >
                          Mark as Delivered
                        </Button>
                      </div>
                      <div
                        style={{
                          cursor: order?.isPaid ? "not-allowed" : "pointer",
                        }}
                      >
                        <FormControlLabel
                          control={
                            <IOSSwitch
                              checked={!!order?.isPaid}
                              onChange={handleMarkAsPaid}
                              color="primary"
                              disabled={(order?.delivery_status !== "DELIVERED" ||
                                !!order?.isPaid) || !ordersGate.allowed}
                              title={ordersGate.title}
                            />
                          }
                          label={
                            <span style={{ fontSize: "13px" }}>
                              {order?.isPaid ? "Paid" : "Mark as Paid"}
                            </span>
                          }
                        />
                      </div>
                    </Col>
                  </Row>
                </>
              ) : (
                <div className="text-center py-5">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Modal show={showCancelModal} onHide={() => { setShowCancelModal(false); cancelReason.reset(); }}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Cancellation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to cancel this order?
          <CancelOrderFields state={cancelReason} isPaid={!!order?.isPaid} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCancelModal(false)}>
            Close
          </Button>
          <Button variant="danger" onClick={handleCancelOrder}>
            Cancel Order
          </Button>
        </Modal.Footer>
      </Modal>

      {order &&
        order.orderItems &&
        order.orderItems[0] &&
        (order.orderItems[0].outletId || order.orderItems[0].vendorId) ? (
        <Card className="shadow-sm mt-4 distance-info-card rod-distance-card">
          <Card.Header
            className="gradient-header"
            style={{
              color: "white",
              padding: "1.5rem",
            }}
          >
            <h4 style={{ margin: 0, display: "flex", alignItems: "center", fontSize: "16px", fontWeight: 700 }}>
              <MdLocationOn style={{ marginRight: "10px", fontSize: "18px" }} />
              Delivery Distance Information
            </h4>
          </Card.Header>
          <Card.Body className="rod-distance-body" style={{ padding: "1.5rem" }}>
            <Row>
              <Col md={4} className="rod-distance-col">
                <div className="info-box">
                  <h5
                    className="rod-info-box-title"
                    style={{
                      color: "#193C40",
                      marginBottom: "1.2rem",
                      display: "flex",
                      alignItems: "center",
                      fontSize: "14px",
                      fontWeight: 700,
                    }}
                  >
                    <MdStorefront
                      style={{ marginRight: "8px", fontSize: "18px" }}
                    />
                    {order?.orderItems[0]?.isOutletOrder
                      ? "Outlet Details"
                      : "Restaurant Details"}
                  </h5>
                  <div className="rod-info-field" style={{ marginBottom: "1rem" }}>
                    <strong style={{ color: "#495057", fontSize: "12px", fontWeight: 600 }}>Name:</strong>
                    <p className="info-field" style={{ margin: "4px 0 12px 0", fontSize: "13px" }}>
                      {order?.orderItems[0]?.outletId?.name ||
                        order?.orderItems[0]?.parentRestaurantId?.name ||
                        order?.orderItems[0]?.parentRestaurantId?.businessName ||
                        order?.orderItems[0]?.restaurantData?.name ||
                        order?.orderItems[0]?.vendorId?.businessName ||
                        order?.orderItems[0]?.vendorId?.name ||
                        'N/A'}
                    </p>
                  </div>
                  <div className="rod-info-field" style={{ marginBottom: "1rem" }}>
                    <strong style={{ color: "#495057", fontSize: "12px", fontWeight: 600 }}>Address:</strong>
                    <p className="info-field" style={{ margin: "4px 0 12px 0", fontSize: "13px" }}>
                      {order?.orderItems[0]?.outletId?.address ||
                        order?.orderItems[0]?.parentRestaurantId?.address ||
                        order?.orderItems[0]?.restaurantData?.address ||
                        order?.orderItems[0]?.vendorId?.businessAddress ||
                        order?.orderItems[0]?.vendorId?.address ||
                        'N/A'}
                    </p>
                  </div>
                  <div>
                    <strong style={{ color: "#495057", fontSize: "12px", fontWeight: 600 }}>Delivery Zone:</strong>
                    <div
                      className="info-field"
                      style={{
                        margin: "4px 0",
                        display: "flex",
                        alignItems: "center",
                        fontSize: "13px",
                      }}
                    >
                      <MdRadar
                        style={{ marginRight: "8px", color: "#193C40" }}
                      />
                      {`${order?.orderItems[0]?.outletId?.deliveryZoneRadius ||
                        order?.orderItems[0]?.parentRestaurantId?.deliveryZoneRadius ||
                        order?.orderItems[0]?.restaurantData?.deliveryZoneRadius ||
                        order?.orderItems[0]?.vendorId?.deliveryZoneRadius ||
                        'N/A'
                        } km radius`}
                    </div>
                  </div>
                </div>
              </Col>
              <Col md={4} className="rod-distance-col">
                <div className="info-box">
                  <h5
                    className="rod-info-box-title"
                    style={{
                      color: "#193C40",
                      marginBottom: "1.2rem",
                      display: "flex",
                      alignItems: "center",
                      fontSize: "14px",
                      fontWeight: 700,
                    }}
                  >
                    <MdPerson
                      style={{ marginRight: "8px", fontSize: "18px" }}
                    />
                    Customer Details
                  </h5>
                  <div className="rod-info-field" style={{ marginBottom: "1rem" }}>
                    <strong style={{ color: "#495057", fontSize: "12px", fontWeight: 600 }}>Name:</strong>
                    <p className="info-field" style={{ margin: "4px 0 12px 0", fontSize: "13px" }}>
                      {order?.customerName || 'N/A'}
                    </p>
                  </div>
                  <div className="rod-info-field" style={{ marginBottom: "1rem" }}>
                    <strong style={{ color: "#495057", fontSize: "12px", fontWeight: 600 }}>Phone:</strong>
                    <div style={{ margin: "4px 0 12px 0", fontSize: "13px" }}>
                      <ContactAction
                        label="Customer"
                        name={order?.customerName}
                        phone={order?.shippingAddress?.customerNumber || order?.shippingAddress?.recipientPhone}
                        compact
                        style={{ marginBottom: 10 }}
                      />
                    </div>
                  </div>
                  <div className="rod-info-field" style={{ marginBottom: "1rem" }}>
                    <strong style={{ color: "#495057", fontSize: "12px", fontWeight: 600 }}>Delivery Address:</strong>
                    <p className="info-field" style={{ margin: "4px 0 6px 0", fontSize: '13px' }}>
                      {getShippingAddressText(order?.shippingAddress, "No address recorded")}
                    </p>
                    {/* The same drop-off block as the admin order page: place
                        name, precision chip, Show map, Send pin, Copy pin. The
                        route map modal below stays for the vendor-to-customer
                        distance view. */}
                    {Number.isFinite(Number(order?.shippingAddress?.latLng?.lat)) &&
                      Number.isFinite(Number(order?.shippingAddress?.latLng?.lng)) && (
                        <DropoffMap
                          lat={order.shippingAddress.latLng.lat}
                          lng={order.shippingAddress.latLng.lng}
                          address={getShippingAddressText(order?.shippingAddress, "")}
                          shippingAddress={order?.shippingAddress}
                          orderRef={order?.order_number || order?._id}
                          rider={assignedRider || order?.riderId}
                          country={order?.country}
                        />
                      )}
                  </div>
                </div>
              </Col>
              <Col md={4} className="rod-distance-col">
                <div className="info-box">
                  <h5
                    className="rod-info-box-title"
                    style={{
                      color: "#193C40",
                      marginBottom: "1.2rem",
                      display: "flex",
                      alignItems: "center",
                      fontSize: "14px",
                      fontWeight: 700,
                    }}
                  >
                    <MdAnalytics
                      style={{ marginRight: "8px", fontSize: "18px" }}
                    />
                    Distance Analysis
                  </h5>
                  {!order?.shippingAddress?.latLng ? (
                    <div
                      style={{
                        fontSize: 13,
                        color: "#6b7280",
                        background: "#f8f9fa",
                        border: "1px dashed #d1d5db",
                        borderRadius: 8,
                        padding: "12px 14px",
                        lineHeight: 1.5,
                      }}
                    >
                      <MdDirections style={{ marginRight: 6, color: "#193C40", verticalAlign: "-2px" }} />
                      {Number(order?.distanceKm) > 0
                        ? `Distance to customer: ${Number(order.distanceKm).toFixed(2)} km (from the order's saved delivery distance). A precise map route isn't shown because this delivery address has no saved coordinates.`
                        : "Distance unavailable — this delivery address has no saved coordinates, so the route can't be measured. The delivery fee was set from the zone minimum. New orders capture the customer's coordinates at checkout."}
                    </div>
                  ) : (
                    <>
                      <div style={{ marginBottom: "1rem" }}>
                        <strong style={{ color: "#495057", fontSize: "12px", fontWeight: 600 }}>
                          Distance to Customer:
                        </strong>
                        <div
                          className="info-field"
                          style={{
                            margin: "4px 0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            fontSize: "13px",
                          }}
                        >
                          <span>
                            <MdDirections
                              style={{ marginRight: "8px", color: "#193C40" }}
                            />
                            {(() => {
                              const storeLat =
                                order?.orderItems[0]?.outletId?.latitude ||
                                order?.orderItems[0]?.parentRestaurantId?.latitude ||
                                order?.orderItems[0]?.restaurantData?.latitude ||
                                order?.orderItems[0]?.vendorId?.latitude ||
                                order?.pickupAddress?.latLng?.lat;
                              const storeLng =
                                order?.orderItems[0]?.outletId?.longitude ||
                                order?.orderItems[0]?.parentRestaurantId?.longitude ||
                                order?.orderItems[0]?.restaurantData?.longitude ||
                                order?.orderItems[0]?.vendorId?.longitude ||
                                order?.pickupAddress?.latLng?.lng;
                              const custLat =
                                order?.shippingAddress?.latLng?.lat;
                              const custLng =
                                order?.shippingAddress?.latLng?.lng;

                              const hasServerKm = Number(order?.distanceKm) > 0;
                              if (
                                !hasServerKm &&
                                (!storeLat || !storeLng || !custLat || !custLng)
                              ) {
                                return "-- km";
                              }

                              const km = hasServerKm
                                ? Number(order.distanceKm)
                                : Number(
                                    calculateDistance(
                                      storeLat,
                                      storeLng,
                                      custLat,
                                      custLng
                                    )
                                  );

                              return (
                                <>
                                  {`${km.toFixed(2)} km`}
                                  <span
                                    style={{
                                      marginLeft: 6,
                                      fontSize: "10px",
                                      color: "#9ca3af",
                                      fontWeight: 500,
                                    }}
                                  >
                                    {hasServerKm ? "road" : "approx"}
                                  </span>
                                </>
                              );
                            })()}
                          </span>
                          {(() => {
                            const storeLat =
                              order?.orderItems[0]?.outletId?.latitude ||
                              order?.orderItems[0]?.parentRestaurantId?.latitude ||
                              order?.orderItems[0]?.restaurantData?.latitude ||
                              order?.orderItems[0]?.vendorId?.latitude ||
                              order?.pickupAddress?.latLng?.lat;
                            const storeLng =
                              order?.orderItems[0]?.outletId?.longitude ||
                              order?.orderItems[0]?.parentRestaurantId?.longitude ||
                              order?.orderItems[0]?.restaurantData?.longitude ||
                              order?.orderItems[0]?.vendorId?.longitude ||
                              order?.pickupAddress?.latLng?.lng;
                            const custLat = order?.shippingAddress?.latLng?.lat;
                            const custLng = order?.shippingAddress?.latLng?.lng;
                            const km =
                              Number(order?.distanceKm) > 0
                                ? Number(order.distanceKm)
                                : Number(
                                    calculateDistance(
                                      storeLat,
                                      storeLng,
                                      custLat,
                                      custLng
                                    )
                                  );
                            const zoneRadius =
                              order?.orderItems[0]?.outletId
                                ?.deliveryZoneRadius ||
                              order?.orderItems[0]?.parentRestaurantId
                                ?.deliveryZoneRadius ||
                              order?.orderItems[0]?.restaurantData
                                ?.deliveryZoneRadius ||
                              order?.orderItems[0]?.vendorId
                                ?.deliveryZoneRadius;

                            return km > zoneRadius ? (
                              <Chip
                                label="Outside Zone"
                                style={{
                                  backgroundColor: "#dc3545",
                                  color: "white",
                                  fontSize: "12px",
                                }}
                              />
                            ) : (
                              <Chip
                                label="Within Zone"
                                style={{
                                  backgroundColor: "#28a745",
                                  color: "white",
                                  fontSize: "12px",
                                  boxShadow: "0 2px 5px rgb(241, 146, 13, 0.8)",
                                }}
                              />
                            );
                          })()}
                        </div>
                      </div>
                      {(() => {
                        const storeLat =
                          order?.orderItems[0]?.outletId?.latitude ||
                          order?.orderItems[0]?.parentRestaurantId?.latitude ||
                          order?.orderItems[0]?.restaurantData?.latitude ||
                          order?.orderItems[0]?.vendorId?.latitude ||
                          order?.pickupAddress?.latLng?.lat;
                        const storeLng =
                          order?.orderItems[0]?.outletId?.longitude ||
                          order?.orderItems[0]?.parentRestaurantId?.longitude ||
                          order?.orderItems[0]?.restaurantData?.longitude ||
                          order?.orderItems[0]?.vendorId?.longitude ||
                          order?.pickupAddress?.latLng?.lng;
                        const custLat = order?.shippingAddress?.latLng?.lat;
                        const custLng = order?.shippingAddress?.latLng?.lng;
                        const km =
                          Number(order?.distanceKm) > 0
                            ? Number(order.distanceKm)
                            : Number(
                                calculateDistance(
                                  storeLat,
                                  storeLng,
                                  custLat,
                                  custLng
                                )
                              );
                        const zoneRadius =
                          order?.orderItems[0]?.outletId?.deliveryZoneRadius ||
                          order?.orderItems[0]?.parentRestaurantId?.deliveryZoneRadius ||
                          order?.orderItems[0]?.restaurantData?.deliveryZoneRadius ||
                          order?.orderItems[0]?.vendorId?.deliveryZoneRadius;

                        return km > zoneRadius ? (
                          <Alert
                            variant="warning"
                            style={{
                              borderRadius: "8px",
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <MdWarning size={20} />
                            {`Customer is outside the ${order?.orderItems[0]?.isOutletOrder
                              ? "outlet's"
                              : "restaurant's"
                              } delivery zone (${zoneRadius}km)`}
                          </Alert>
                        ) : null;
                      })()}
                      <div className="mt-4">
                        <Button
                          variant="info"
                          className="enhanced-button"
                          style={{
                            background: "linear-gradient(135deg,rgb(28, 64, 25) 0%, #45a29e 100%)",
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            width: "100%",
                            justifyContent: "center",
                          }}
                          onClick={() => setShowMapModal(true)}
                        >
                          <MdMap size={20} />
                          View Route on Map
                        </Button>
                      </div>
                    </>
                  )}
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      ) : null}

      <Modal
        show={showMapModal}
        onHide={() => setShowMapModal(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="rod-map-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delivery Route Map</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "70vh", padding: 0 }}>
          <iframe
            title="Delivery Route"
            width="100%"
            height="100%"
            frameBorder="0"
            style={{ border: 0 }}
            src={`https://www.google.com/maps/embed/v1/directions?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY
              }
              &origin=${order?.orderItems[0]?.outletId?.latitude ||
              order?.orderItems[0]?.parentRestaurantId?.latitude ||
              order?.orderItems[0]?.restaurantData?.latitude ||
              order?.orderItems[0]?.vendorId?.latitude ||
              order?.pickupAddress?.latLng?.lat ||
              ''
              },${order?.orderItems[0]?.outletId?.longitude ||
              order?.orderItems[0]?.parentRestaurantId?.longitude ||
              order?.orderItems[0]?.restaurantData?.longitude ||
              order?.orderItems[0]?.vendorId?.longitude ||
              order?.pickupAddress?.latLng?.lng ||
              ''
              }
              &destination=${order?.shippingAddress?.latLng?.lat},${order?.shippingAddress?.latLng?.lng
              }
              &mode=driving`}
            allowFullScreen
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowMapModal(false)}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              const storeLoc = `${order?.orderItems[0]?.outletId?.latitude ||
                order?.orderItems[0]?.parentRestaurantId?.latitude ||
                order?.orderItems[0]?.restaurantData?.latitude ||
                order?.orderItems[0]?.vendorId?.latitude ||
                order?.pickupAddress?.latLng?.lat ||
                ''
                },${order?.orderItems[0]?.outletId?.longitude ||
                order?.orderItems[0]?.parentRestaurantId?.longitude ||
                order?.orderItems[0]?.restaurantData?.longitude ||
                order?.orderItems[0]?.vendorId?.longitude ||
                order?.pickupAddress?.latLng?.lng ||
                ''
                }`;
              const customerLoc = `${order?.shippingAddress?.latLng?.lat},${order?.shippingAddress?.latLng?.lng}`;
              window.open(
                `https://www.google.com/maps/dir/${storeLoc}/${customerLoc}`,
                "_blank"
              );
            }}
          >
            Open in Google Maps
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Recall Order Confirmation Modal */}
      <Modal show={showRecallModal} onHide={() => setShowRecallModal(false)} centered>
        <Modal.Header closeButton style={{ borderBottom: "none", paddingBottom: 0 }}>
          <Modal.Title style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <MdUndo style={{ color: "#dc2626", fontSize: "18px" }} />
            Recall Order
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ paddingTop: "12px" }}>
          <p style={{ marginBottom: "12px" }}>
            Are you sure you want to recall this order from{" "}
            <strong>{order?.assignmentDetails?.partnerId?.companyName || "the 3PL partner"}</strong>?
          </p>
          <Alert style={{ fontSize: "13px", marginBottom: 0, backgroundColor: "rgba(5, 17, 68, 1)" }}>
            <strong>Note:</strong> This will remove the order from the 3PL partner's queue and return it to your processing list.
          </Alert>
        </Modal.Body>
        <Modal.Footer style={{ borderTop: "none", paddingTop: 0 }}>
          <Button
            variant="outline-secondary"
            onClick={() => setShowRecallModal(false)}
            style={{ borderRadius: "8px" }}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={recallOrderFrom3PL}
            disabled={(recalling3PL) || !ordersGate.allowed}
            title={ordersGate.title}
            style={{
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              gap: "6px"
            }}
          >
            {recalling3PL ? (
              <>
                <Spinner animation="border" size="sm" />
                Recalling...
              </>
            ) : (
              <>
                <MdUndo />
                Confirm Recall
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default RestaurantVendorOrderDetails;
